/**
 * @file   src\components\MemberWantAd\NiceToHave\Exterior.js
 * @brief  This file is responsible for nice to have selection in want ad creation
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const Exterior = (props) => {
    const {exterior, handleItemClick, itemArray} = props
    return  <NiceToHaveHelper
       list={exterior}
       selectedItems={itemArray}
       propertyClick={handleItemClick}
    />
};
export default Exterior;
